<script lang="ts">
    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { simpleFetch, type SimpleFetchResult } from 'hydria/services/session'
    import { getContext, onDestroy } from 'svelte'
    import { fade } from 'svelte/transition'
    import { lg } from 'hydria/services/language'
    import type { Writable } from 'svelte/store'

    interface Props {
        tokenExpired: () => void
        saved: () => void
        close: () => void
    }

    let { tokenExpired, saved, close }: Props = $props()

    let stoken = getContext('securityToken') as Writable<string>

    let saving = $state(false)

    async function save() {
        if (saving) return

        saving = true
        let r: SimpleFetchResult
        try {
            r = await simpleFetch('PUT', '/json/security/1/twofa-email', { lg: $lg }, { headers: { 'x-security-token': $stoken } })
        } catch (e: any) {
            r = e
        }
        if (r && r.data && r.data.ecode === 'SEC-TOKEN') {
            tokenExpired()
            return
        }

        if (!r || !r.data || !r.data.success) {
            saving = false
            return
        }

        if (!r.data.saved) {
            saving = false
            return
        }

        notify({
            type: 'success',
            title: $_('Authentification à deux facteurs'),
            text: $_('Votre adresse électronique peut maintenant être utilisée pour la connexion.'),
        })
        saved()
        close()
    }

    let addedModalOpen = false
    if (!document.documentElement.classList.contains('modal-open')) {
        document.documentElement.classList.add('modal-open')
        addedModalOpen = true
    }

    onDestroy(() => {
        if (addedModalOpen && document.documentElement.classList.contains('modal-open')) {
            document.documentElement.classList.remove('modal-open')
        }
    })
</script>

<svelte:window
    onkeydown={(e) => {
        if (e.key === 'Escape') {
            if (!saving) {
                close()
            }
        }
    }}
/>

<div class="modal" role="dialog" transition:fade={{ duration: 250 }}>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header text-bg-primary"><div>{$_('Code par courriel')}</div></div>
            <div class="modal-body">
                <p>{$_('Un code unique sera envoyé à l’adresse courriel de votre compte, et pourra être utilisé pour se connecter.')}</p>
            </div>
            <div class="modal-footer text-bg-light">
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    disabled={saving}
                    onclick={() => {
                        close()
                    }}>{$_('Cancel')}</button
                >
                <button
                    type="button"
                    class="btn btn-primary"
                    onclick={() => {
                        save()
                    }}
                    disabled={saving}
                >
                    {#if saving}<div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                        {$_('Un moment…')}
                    {:else}{$_('Activer')}
                    {/if}
                </button>
            </div>
        </div>
    </div>
    <div
        class="modal-backdrop"
        onclick={() => {
            if (!saving) close()
        }}
        aria-hidden="true"
    ></div>
</div>
